module.exports = __webpack_public_path__ + "img/whatsapp.0223112a.svg";